// Locale-aware URL helpers for cross-subsite links from the React app
// to the VitePress docs (mounted at /docs/) and the Astro blog (mounted
// at /blog/). Both subsites support locale-prefixed routes for every
// non-English language we ship; rewriting the link here keeps a user
// who picked, say, French from being dropped onto an English page when
// they click "Docs" or "Blog" in the landing nav.
//
// Casing notes:
// - Docs (VitePress) keeps canonical BCP-47 casing in URL paths
//   ("es-ES", "pt-BR", "zh-CN"), matching the directory names under
//   docs/.
// - Blog (Astro glob loader) lowercases directory names, so the URL
//   form is "es-es", "pt-br", "zh-cn". `langToBlogUrl` mirrors the
//   helper that lives in blog/src/i18n/languages.ts; we redefine it
//   here so the React app doesn't need to import across subprojects.
// - English content is the unprefixed root in both subsites, so a
//   user on `en` keeps the original href unchanged.

const langToBlogUrl = (lang: string): string => lang.toLowerCase();

export function localizedDocsHref(path: string, lang: string): string {
  if (lang === 'en') return path;
  return path.replace(/^\/docs(\/|$)/, `/docs/${lang}$1`);
}

export function localizedBlogHref(path: string, lang: string): string {
  if (lang === 'en') return path;
  return path.replace(/^\/blog(\/|$)/, `/blog/${langToBlogUrl(lang)}$1`);
}
